module.exports = __webpack_public_path__ + "static/css-page-8-3-fe7a05a900d5eb0195fa88dda61f6fad.jpg";